import { Component } from '@angular/core';

@Component({
  selector: 'app-no-permissions',
  templateUrl: './no-permissions.component.html',
  styleUrls: ['./no-permissions.component.css'],
})
export class NoPermissionsComponent {}
